import { fromJS } from 'immutable';
import { createReducer } from 'reducers/utils/helpers';
import { clientTimeline } from './types';

export * from './actions';

const initialState = fromJS({
  data: [],
  network: {
    loading: false,
    error: false,
    success: false,
  },
});

export default createReducer(initialState, {
  [clientTimeline.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [clientTimeline.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['data'], action.response),
    ),
  [clientTimeline.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
});
